import React, { useEffect, useRef } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
import GoalTemplate from '../GoalAlarmGoal/Index';
import "./style/style.scss";
import "./style/animation.scss";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import getContentById from "../../../../shared/utils/getContentById";
import anime from "animejs";
import GoalIntro from './Intro';
import BildHeaderComponent from "../../../../shared/components/TimelinePreview/BildHeaderComponent";
const getMainBackground = () => {
  return assets.background_1920;
};

const radius = 30;
const goalRadius = 50;
const width = 929;
const height = 669;
const wholeFieldHeight = height * 2;
const cutoff = height;

function getCssCoord(y, height, r) {
  const ratio = height / 100;

  return y * ratio - r * 2;
}

function getCssBottom(x, r = radius) {
  return getCssCoord(x, wholeFieldHeight, r) - cutoff;
}

function getCssRight(y, r = radius) {
  const value = getCssCoord(y, width, r);
  return value < 0 ? 0 : value;
}

function getSvgX(y, r) {
  return width - getCssRight(y, r) - r;
}

function getSvgY(x, r) {
  return height - getCssBottom(x, r) - r;
}

function getSvgPoint(x, y, r = radius) {
  return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, ...props }) {
  const { t } = useTranslation();

  const id = `bild_goal_alarm_${data?.id}`;
  const contestantId = data?.contestantId;
  const contestantTeam = data?.matchInfo?.contestant.find(
    (c) => c.id === contestantId,
  );
  const teamSide = contestantTeam?.position ?? "home";

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
        });

        animationReturn.timeline.play();
        // 
        setTimeout(() => {
          anime({
            targets: cardRef.current,
            rotateX: '-180',
            duration: 1000,
            easing: 'easeInOutQuad',
          })
        }, 6000);
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const cardRef = useRef(null);
  return (
    <div
      id={id}
      // className={`T_bild_goal_alarm ${animation ? "animation" : ""} side-${teamSide}`}
      style={{
        perspective: '1920px',
        backgroundColor: 'rgb(253, 188, 1)'
      }}
    >
      {/* <BildHeaderComponent data={data} otherData={activeSlot === "current" ? slotNextData : slotCurrentData} /> */}
      <div>Header title flaps</div>
      <div
        ref={cardRef}
        style={{
          width: '1920px',
          height: '1080px',
          position: 'absolute',
          transformStyle: 'preserve-3d',
          transform: 'rotateX(0deg)',
        }}>
        <div
          className="child-template-container"
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
          }}
        >
          <GoalIntro data={data} />
        </div>
        <div
          className={"template-container"}
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateX(180deg)',
          }}>
          <GoalTemplate
            data={data}
            animation={animation}
            mode={mode}
            format={format}
          />
        </div>
      </div>
    </div>
  );
}
